import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BellRing } from "lucide-react";
import { BRAND } from "@/constants/compliance";

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-[#211D1A] text-[#FAF8F5] overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 sm:pt-28 pb-10">
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="font-display font-extrabold tracking-tighter leading-[0.95] text-[13vw] sm:text-[9vw] lg:text-[7.5rem] text-[#FAF8F5]"
        data-testid="footer-brand"
      >
        RemindMe <span className="text-[#D96B43] italic">&</span> Do
      </motion.h2>

      <div className="mt-14 grid md:grid-cols-3 gap-10 border-t border-white/10 pt-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-8 h-8 rounded-full bg-[#D96B43] flex items-center justify-center">
              <BellRing size={15} strokeWidth={2.4} />
            </span>
            <span className="font-display font-bold">{BRAND.name}</span>
          </div>
          <p className="text-sm text-[#FAF8F5]/60 leading-relaxed max-w-xs">
            Gentle automated SMS reminders for the tasks that run your day.
            No app. No clutter. Just a text.
          </p>
        </div>

        <div>
          <p className="font-mono2 text-[11px] tracking-[0.2em] uppercase text-[#FAF8F5]/40 mb-4">
            Navigate
          </p>
          <div className="flex flex-col gap-2.5">
            <Link to="/" data-testid="footer-link-home" className="text-sm text-[#FAF8F5]/75 hover:text-[#D96B43] transition-colors w-fit">
              Home
            </Link>
            <Link to="/terms" data-testid="footer-link-terms" className="text-sm text-[#FAF8F5]/75 hover:text-[#D96B43] transition-colors w-fit">
              Terms of Service
            </Link>
            <Link to="/privacy" data-testid="footer-link-privacy" className="text-sm text-[#FAF8F5]/75 hover:text-[#D96B43] transition-colors w-fit">
              Privacy Policy
            </Link>
            <a href="https://app.minemeanddo.com" data-testid="footer-link-app" className="text-sm text-[#FAF8F5]/75 hover:text-[#D96B43] transition-colors w-fit">
              Dashboard app
            </a>
          </div>
        </div>

        <div>
          <p className="font-mono2 text-[11px] tracking-[0.2em] uppercase text-[#FAF8F5]/40 mb-4">
            SMS program disclosure
          </p>
          <p data-testid="footer-disclosure" className="text-xs text-[#FAF8F5]/55 leading-relaxed max-w-sm">
            Text {BRAND.keyword} to {BRAND.number} to opt in to recurring
            automated task reminder messages from {BRAND.name}. Consent is not
            a condition of purchase. Message frequency varies. Message & data
            rates may apply. Reply HELP for help, STOP to cancel. See our{" "}
            <Link to="/terms" data-testid="footer-disclosure-terms-link" className="underline underline-offset-2 hover:text-[#D96B43]">
              Terms
            </Link>{" "}
            and{" "}
            <Link to="/privacy" data-testid="footer-disclosure-privacy-link" className="underline underline-offset-2 hover:text-[#D96B43]">
              Privacy Policy
            </Link>
            .
          </p>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-xs text-[#FAF8F5]/40">
          © {new Date().getFullYear()} {BRAND.name} · {BRAND.domain}
        </p>
        <p className="font-mono2 text-[11px] tracking-[0.2em] uppercase text-[#FAF8F5]/40">
          Text {BRAND.keyword} · Reply STOP anytime
        </p>
      </div>
    </div>
  </footer>
);
